import { UserSettingsTicketsTab } from '@libero/api-client/auth-user/types';
import { useUserStore } from '@libero/hooks/store/useUserStore';
import { pick } from 'lodash';
import QueryString from 'qs';
import type { LocationQuery, LocationQueryRaw, RouteLocation, RouterOptions } from 'vue-router';

import { isMobile } from './mobile';

export const defaultRouterOptions: Partial<RouterOptions> = {
  parseQuery: (value: string) => {
    return QueryString.parse(value) as LocationQuery;
  },
  stringifyQuery: (query: LocationQueryRaw) => {
    const sortedQuery = pick(query, [
      'per_page',
      'page',
      'sort',
      ...Object.keys(query).sort(),
      'view',
    ]);
    return QueryString.stringify(sortedQuery, { encode: false }) as string;
  },
};

export const getTicketsTab = (currentRoute: RouteLocation): string | undefined => {
  const userStore = useUserStore();

  if (isMobile()) {
    return 'properties';
  }

  const fromName = currentRoute.name as string;
  const defaultTab = userStore.user?.settings.tickets_tab || UserSettingsTicketsTab.JobSheet;

  return fromName?.startsWith('ticket.edit') ? fromName.split('.').pop() : defaultTab;
};
